// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import BookingController from './booking_controller'
application.register('booking', BookingController)

import LightboxController from './lightbox_controller'
application.register('lightbox', LightboxController)

import NestedFormController from './nested_form_controller'
application.register('nested-form', NestedFormController)

import NoticeController from './notice_controller'
application.register('notice', NoticeController)

import PrivacyController from './privacy_controller'
application.register('privacy', PrivacyController)

import RichtextController from './richtext_controller'
application.register('richtext', RichtextController)
